type ModalVideoProvider = "vimeo" | "youtube" | "youku" | "custom";

interface VideoInfo {
  provider?: ModalVideoProvider;
  videoId?: string;
}

export const extractProviderAndVideoId = (url: string): VideoInfo => {
  let videoId: string | undefined;
  let provider: ModalVideoProvider | undefined;

  // Check if it's a YouTube URL
  const youTubeRegex =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([^&\n?]+)/;
  if (youTubeRegex.test(url)) {
    const match = url.match(youTubeRegex);
    if (match) {
      videoId = match[1];
      provider = "youtube" as const;
    }
  }

  // Check if it's a Vimeo URL
  const vimeoRegex = /(?:vimeo\.com\/)([^&\n?]+)/;
  if (vimeoRegex.test(url)) {
    const match = url.match(vimeoRegex);
    if (match) {
      videoId = match[1];
      provider = "vimeo" as const;
    }
  }

  // Return an object with the provider and video ID
  return { provider, videoId };
};
